export default __webpack_public_path__ + "static/media/gamestack-login-large.44020927.jpg";